import { render, staticRenderFns } from "./mobile-nav.vue?vue&type=template&id=4b071177&"
import script from "./mobile-nav.vue?vue&type=script&lang=ts&"
export * from "./mobile-nav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports